import useLayoutSize, { LayoutSize } from './utils/useLayoutSize';

const useCanDisplayPostHistoryView = () => {
  const layoutSize = useLayoutSize();
  return (
    layoutSize && ![LayoutSize.mobile, LayoutSize.tablet].includes(layoutSize)
  );
};

export default useCanDisplayPostHistoryView;
